export default __webpack_public_path__ + "static/media/orisa-ult.74fddc72.mp3";